import { NgModule, Injectable, Inject } from '@angular/core';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { LoiHttpClient } from 'loi-lti-common';

const APP_LANG = 'nl-NL';

@Injectable({
  providedIn: 'root'
})
export class TranslationLoaderService implements TranslateLoader {
  constructor(private loiHttpClient: LoiHttpClient, @Inject('BASE_URL') private baseUrl: string) { }
  getTranslation(lang: string): Observable<any> {
    return this.loiHttpClient.get(`${this.baseUrl}api/translation/${lang}`);
  }
}

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  constructor(private translateService: TranslateService) { }

  getTranslation(lang: string) {
    return this.translateService.getTranslation(lang);
  }

  get(translationKey: string, interpolation?: any): Observable<string> {
    return this.translateService.get(translationKey, interpolation);
  }

  getInstant(translationKey: string): string {
    return this.translateService.instant(translationKey);
  }

  init() {
    this.translateService.use(APP_LANG);
  }
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslationLoaderService
      }
    })
  ],
  providers: [TranslationLoaderService, TranslationService],
  exports: [TranslateModule]
})
export class TranslationModule {
  constructor(private translateService: TranslationService) {
    this.translateService.init();
  }
}
